<template>
    <colored-number :value="value" :format="$options.filters.price"></colored-number>
</template>

<script>
    import ColoredNumber from '@/components/Numbers/ColoredNumber'
    
    export default {
        components: {ColoredNumber},
        
        props: ['value']
    }
</script>
